import React from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import "./CourseDetails.css"

export default function CourseDetails({course, institute, jawab, period, title, startDate, endDate})
{
    const openJawab = url => {
        window.open(`${process.env.REACT_APP_ARAZ_JAWAB_URL}?code=${url}`, '_blank', 'noopener,noreferrer');
    };
    let courseName = ""
    let instituteName = ""
    courseName = (course.length > 30) ? course.slice(0, 30) + '...' : course
    instituteName = (institute.length > 30) ? institute.slice(0, 30) + '...' : institute
    let courseDate = (startDate !== '0000-00-00' && endDate !== '0000-00-00') ? `From: ${new Date(startDate).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" })} To: ${new Date(endDate).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" })}` : '';
    return (
        <div className={`user-courses-container ${period}`}>
            <div className='course-category'>{title}</div>
            <div className='course-container'>
                {course ?
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{course}</Tooltip>}>
                        <div className='course-text'>{courseName}</div>
                    </OverlayTrigger> :
                    <div className='course-text'>---</div>
                }
                {institute ?
                    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{institute}</Tooltip>}>
                        <div className='course-text'>{instituteName}</div>
                    </OverlayTrigger> :
                    <div className='course-text'>---</div>
                }
                { courseDate && <div className='course-text'>{courseDate}</div> }
            </div>
            {jawab !== "" ?
            <div className={`jawab-button success-btn`} onClick={() => openJawab(jawab)}>View Jawab</div> :
            <div className={`jawab-button danger-btn cursor-block ${!course && "hide"}`}>No Araz</div>
            }
        </div>
    )
}